import axios from 'axios';
import qs from 'qs';

const rhfFormatedErrors = data => {
    const formatedErrors = {};

    const formatError = (obj, parentObj) => {
        Object.entries(obj).forEach(([key, value]) => {
            if (Array.isArray(value)) {
                if (typeof value[0] === 'object') {
                    parentObj[key] = {};
                    value.forEach((item, index) => {
                        parentObj[key][index] = {};
                        formatError(item, parentObj[key][index]);
                    });
                } else {
                    parentObj[key] = {
                        type: 'server',
                        message: value,
                    };
                }
            } else if (typeof value === 'object') {
                parentObj[key] = {};
                formatError(value, parentObj[key]);
            } else {
                parentObj[key] = {
                    type: 'server',
                    message: [value],
                };
            }
        });
    };

    formatError(data, formatedErrors);
    return formatedErrors;
};

const axiosInstance = axios.create({
    baseURL: import.meta.env.VITE_API_URL,
    headers: {
        'X-User-Timezone': Intl.DateTimeFormat().resolvedOptions().timeZone,
    },
    paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' }),
    formSerializer: {
        indexes: true,
    },
});

axiosInstance.interceptors.response.use(
    response => response,
    error => {
        if (error.response.status === 400) {
            error.response.data = rhfFormatedErrors(error.response.data);
        }
        return Promise.reject(error);
    },
);

export default axiosInstance;
